import Tabs from './src/tabs'
import Pane from './src/pane'

const Plugin = {
  install(Vue) {
    Vue.component(Tabs.name, Tabs)
    Vue.component(Pane.name, Pane)
  }
}

export default Plugin
